<div class="footer d-flex justify-content-between border-0">
  <button type="button" class="btn btn-success fw-bold" (click)="emitResponse(0)">
    Confirm
  </button>
</div>
